import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#9333EA]';
  const variantStyles = {
    primary: 'bg-[#9333EA] text-white hover:bg-[#7B2D7B] border border-transparent shadow-md',
    outline: 'bg-transparent text-[#9333EA] hover:bg-[#F5E6F5] border-2 border-[#9333EA]',
    ghost: 'bg-transparent text-[#9333EA] hover:bg-[#F5E6F5] border border-transparent'
  };
  const sizeStyles = {
    sm: 'text-sm px-3 py-2',
    md: 'text-sm px-5 py-2.5',
    lg: 'text-base px-8 py-3.5'
  };
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-555">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-556">
      {children}
    </button>;
}